import React from 'react'
import styled from 'styled-components'
import Form from 'antd/lib/form'
require('antd/lib/form/style')

import { Colors, Fonts, Shadows } from '../../Themes'

const WrappedForm = ({ small, ...props }) => <Form {...props} />

const StyledForm = styled(WrappedForm).attrs({
  hideRequiredMark: true
})`
  && {
    .ant-form-item-label {
      line-height: ${props => (props.small ? 20 : 24)}px;
      label {
        font-size: 12px;
        color: ${Colors.warmGrey};
        ${props => !props.small && Fonts.style.bold};
      }
    }
    .has-error .ant-input,
    .has-error .ant-select-selection {
      border-color: ${Colors.paleGrey};
      box-shadow: ${Shadows.error};
    }
    .ant-input,
    .ant-input.ant-select-search__field {
      padding: 8px;
      border-radius: 3px;
      font-size: ${props => (props.small ? 14 : 15)}px;
    }
    .ant-input,
    .ant-input.ant-select-search__field,
    .ant-select {
      &::placeholder {
        font-size: ${props => (props.small ? 14 : 15)}px;
        color: ${Colors.whiteFour};
        ${Fonts.style.italic};
      }
    }
    .ant-input,
    .ant-input.ant-select-search__field,
    :not(.ant-select-auto-complete) .ant-select-selection {
      height: ${props => (props.small ? 28 : 40)}px;
      border-color: ${Colors.paleGrey};
      &:not([disabled]):hover,
      &:focus {
        border-color: ${Colors.paleGrey};
        box-shadow: ${Shadows.focus};
      }
    }
    .ant-select-selection__rendered {
      line-height: ${props => (props.small ? 28 : 40)}px;
    }
    .ant-select-selection__placeholder {
      top: ${props => (props.small ? 13 : 20)}px;
      font-size: ${props => (props.small ? 14 : 15)}px;
      color: ${Colors.whiteFour};
      ${Fonts.style.italic};
    }
    .ant-form-explain {
      line-height: 20px;
      font-size: 11px;
    }
    ${props =>
      props.small &&
      `
      .ant-select {
        top: 1px;
      }
    `};
    .ant-calendar-picker-icon::after {
      display: none;
    }
    .ant-select-arrow::before {
      color: ${Colors.warmGrey};
    }
  }
`

StyledForm.Item = styled(Form.Item).attrs({
  colon: false
})``

StyledForm.create = Form.create
StyledForm.createFormField = Form.createFormField
export default StyledForm
